<template>
    <cadastro-simples-list
        endpoint="cbo"
        rota-base="/admin/cbo"
        titulo="CBO — CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES"
        titulo-singular="CBO"
        :colunas-extras='[{"campo":"codigo","label":"Código CBO","tipo":"string","maxLength":10}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
